import type {
	LuckyballServiceResponse,
	RelayData,
	RevealTime,
	Season,
	UserBalls
} from '$lib/types';
import axios from 'axios';
import { Dekey, TypedMessage, TypedMessageVersion } from 'dekey-v2-wallet-core';
import { dekeyConfig } from '../../constants';

const apiHost = `${import.meta.env.VITE_AWS_LUCKYBALL_SERVICE_HOST}/luckyball/api/`;

export const getSeason = async (seasonNumber: number) => {
	const url = apiHost + 'getSeason';
	const params: any = {};
	if (seasonNumber > 0) {
		params.seasonId = seasonNumber;
	}
	const resp = await axios.get<LuckyballServiceResponse<Season>>(url, {
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json'
		},
		params
	});
	return resp.data.data;

};

export const getRevealTime = async () => {
	const url = apiHost + 'getRevealTime';
	const resp = await axios.get<LuckyballServiceResponse<RevealTime>>(url, {
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json'
		}
	});
	console.log('getRevealTime', resp.data.data);
	return resp.data.data;
};

export const getUserBalls = async (owner: string, seasonNumber: number) => {
	const params: any = { owner };
	if (seasonNumber > 0) {
		params.seasonId = seasonNumber;
	}
	const url = apiHost + 'getUserBalls';
	const resp = await axios.get<LuckyballServiceResponse<UserBalls>>(url, {
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json'
		},
		params
	});
	if (Array.isArray(resp.data.data)) {
		return undefined;
	}
	return resp.data.data;

};

export const fetchRelayData = async (sid: string): Promise<RelayData> => {
	const url = apiHost + `getRelayData?owner=${sid}`;
	const {
		data: { data }
	} = await axios.get(url);

	return {
		primaryType: 'Relay',
		domain: data.domain,
		types: {
			EIP712Domain: [
				{ name: 'name', type: 'string' },
				{ name: 'version', type: 'string' },
				{ name: 'chainId', type: 'uint256' },
				{ name: 'verifyingContract', type: 'address' }
			],
			Relay: data.types.Relay
		},
		message: data.relayData
	};
};

export const requestReveal = async (sid: string, relayData: RelayData): Promise<string> => {
	const reqData = JSON.stringify(relayData);
	const typeMessage = new TypedMessage();
	const req = {
		params: [sid, reqData]
	};

	const version = TypedMessageVersion.V4;
	const messageHash = await typeMessage.createTypedMessageHash(req, version, sid);

	const dekey = Dekey.createDekeyInstance(dekeyConfig);
	const sResult = await dekey.sign(messageHash);

	if (!sResult) {
		throw new Error('dekey sign failed');
	}

	const { r, s, vsource } = sResult;
	const url = apiHost + 'relayRequestReveal';
	return axios.post(url, {
		owner: sid,
		deadline: relayData?.message.deadline,
		v: vsource,
		r,
		s
	});
};

